import React from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";

import savedCommandsImage from "src/shared/assets/savedCommands.png";
import applyingCommandsImage from "src/shared/assets/applyingCommandsImage.png";

export const SelectedCommands: React.FC = () => {
  return (
    <Stack width={1} direction="column" gap={1}>
      <Stack
        width={1}
        direction="column"
        justifyContent="center"
        alignItems="center"
        gap={1}
      >
        <Typography
          variant="h4"
          color="text.secondary"
          fontWeight={300}
          sx={{
            fontSize: {
              xs: "1.675rem",
              sm: "2.125rem",
            },
          }}
        >
          Applying{" "}
          <Typography
            component="span"
            variant="inherit"
            color="primary"
            fontWeight="inherit"
          >
            Commands
          </Typography>{" "}
          to Selected Text
        </Typography>

        <Typography
          maxWidth={0.7}
          color="text.primary"
          variant="body1"
          textAlign="center"
          sx={{
            fontSize: {
              sm: "1rem",
              xs: "0.875rem",
            },
          }}
        >
          The commands are text-processing actions that allow users to change
          selected text in the way they desire.
        </Typography>
      </Stack>

      <Stack
        width={1}
        marginTop={6}
        direction="row"
        alignItems="center"
        gap={4}
        sx={{
          flexDirection: {
            md: "row",
            xs: "column-reverse",
          },
        }}
      >
        <Box
          width={1}
          component="img"
          src={savedCommandsImage}
          alt="savedCommandsImage"
          sx={{
            objectFit: "contain",
            overflow: "hidden",
          }}
        />

        <Divider
          orientation="vertical"
          flexItem
          sx={{
            borderColor: "text.primary",
            flexDirection: {
              md: "flex",
              xs: "none",
            },
          }}
        />

        <Box
          width={1}
          component="img"
          src={applyingCommandsImage}
          alt="applyingCommandsImage"
          sx={{
            objectFit: "contain",
            overflow: "hidden",
          }}
        />
      </Stack>
    </Stack>
  );
};
